import { Filter } from '../types/Filters';

export const filterSpaceIds: Filter[] = [
  {
    key: 'spaceIds',
    label: 'Space ID',
  },
];

export const defaultFilterValues: Filter[] = [
  {
    key: 'mediaOwnerNames',
    label: 'Media Owner',
  },
  {
    key: 'environments',
    label: 'Environment',
  },
  {
    key: 'formatSizeNames',
    label: 'Format Size',
  },
  {
    key: 'statuses',
    label: 'Status',
  },
];
